import { config } from '../../../config';

export type ModuleId = 'website_builder' | 'domain_manager' | 'email_setup' | 'gbp_opt' | 'bizbuilding' | 'lifeos' | 'billing' | 'projects';
export type ExecutionStatus = 'pending' | 'running' | 'verifying' | 'completed' | 'failed' | 'cancelled';
export type Priority = 'standard' | 'urgent';

export interface ModuleExecutionRequest {
    clientId: string;
    moduleId: ModuleId;
    workflowId?: string;
    params: Record<string, any>;
    priority: Priority;
}

export interface ModuleExecutionResponse {
    executionId: string;
    result?: any;
}

export interface ModuleStatusResponse {
    executionId: string;
    status: ExecutionStatus;
    currentStage: string;
    progress: number;
    logs: string[];
    artifacts: {
        url?: string;
        report?: string;
        [key: string]: any;
    };
}

export const executeModule = async (request: ModuleExecutionRequest): Promise<ModuleExecutionResponse> => {
    console.log(`[ModulesAPI] Executing module ${request.moduleId} for client ${request.clientId}...`);

    const response = await fetch(`${config.API_BASE_URL}/api/modules/execute`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            clientId: request.clientId,
            moduleId: request.moduleId,
            workflowId: request.workflowId,
            params: request.params,
            priority: request.priority,
        }),
    });

    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({ error: response.statusText }));
        throw new Error(errorBody.error || `Module execution failed: ${response.statusText}`);
    }

    const result = await response.json();
    const executionId = result.executionId || `exec_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

    return { executionId, result: result.result };
};

export const getModuleStatus = async (executionId: string): Promise<ModuleStatusResponse> => {
    console.log(`[ModulesAPI] Fetching status for execution ${executionId}...`);

    const response = await fetch(`${config.API_BASE_URL}/api/modules/status/${executionId}`);

    if (!response.ok) {
        throw new Error(`Failed to fetch module status: ${response.statusText}`);
    }

    return await response.json();
};

export const modulesApi = {
    executeModule,
    getModuleStatus,
};
